import { Component, OnInit } from '@angular/core';
// import { Auth } from '../../auth/auth.service';

// import { AuthService } from '@auth0/auth0-angular';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    isAuthenticated = false;

    constructor(public router: Router, public oidcSecurityService: OidcSecurityService) { }

    ngOnInit() {
        this.login();
    }

    login() {
        const cartId = localStorage.getItem('cart_id');
        const cnFrameworks = localStorage.getItem('CN_FRAMEWORKS');
        const couponCode = localStorage.getItem('fs_coupon_code');
        localStorage.clear();
        if (window.sessionStorage) {
            window.sessionStorage.clear();
        }
        // Restore before redirect — authorize() navigates away so nothing after it runs
        if (cartId) localStorage.setItem('cart_id', cartId);
        if (cnFrameworks) localStorage.setItem('CN_FRAMEWORKS', cnFrameworks);
        if (couponCode) localStorage.setItem('fs_coupon_code', couponCode);
        this.oidcSecurityService.authorize();
      }

    // logout(): void {
    //     console.log('logout')
    //     this.oidcSecurityService.logoff().subscribe((result)=> {
    //         console.log(result);
    //     });
    // }
}
